module.exports = __webpack_public_path__ + "img/logo-duplicate-killer-m.e2c13bc.png";